import { FileUploadStatsDetails, ChartDataProps } from '../file-tracker-types';
import { useEffect, useState } from 'react';
import { Flex, Icon, Text } from '@chakra-ui/react';
import { SummaryCard, Card, Select } from '@ssar-app/uikit';
import {
  AiOutlineFileDone,
  AiOutlineFileSearch,
  AiOutlineFileProtect,
  AiOutlineArrowUp,
  AiOutlineArrowDown,
} from 'react-icons/ai/index.js';
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip as ChartTooltip,
} from 'recharts';
import { IconType } from 'react-icons';

interface FileStats {
  title: string;
  value: number | string;

  icon: IconType | undefined;
  color: string;
  background: string;
  percentage?: number;
  key?: string;
}
interface SelectOptionProps {
  value: number;
  label: string;
}
interface FileStatusProps {
  fileStatsData: FileUploadStatsDetails;
  chartData: ChartDataProps;
  setSelectedOption: (val: number) => void;
  selectedOption: number;
  SelectOptions: SelectOptionProps[];
  percentageData: FileUploadStatsDetails;
}
export const FileUploadTrend = (props: FileStatusProps) => {
  const {
    fileStatsData,
    chartData,
    setSelectedOption,
    SelectOptions,
    selectedOption,
    percentageData,
  } = props;

  const getStatusStats = (stats: FileUploadStatsDetails) => {
    return [
      {
        title: 'File is available',
        value: stats.available,
        icon: AiOutlineFileDone,
        color: '#009F4D',
        background: '#D0F6DB',
        key: 'available',
      },
      {
        title: 'File Sampling',
        value: stats.sampling,
        icon: AiOutlineFileSearch,
        color: '#426DA9',
        background: '#D6E3F4',
        key: 'sampling',
      },
      {
        title: 'Malware Scan',
        value: stats.malwareScan,
        icon: AiOutlineFileSearch,
        color: '#A45DAD',
        background: '#F0DEF2',
        key: 'malwareScan',
      },
      {
        title: 'File Received',
        value: stats.received,
        icon: AiOutlineFileProtect,
        color: '#FF8F1C',
        background: '#FFEED7',
        key: 'received',
      },
    ];
  };
  const [fileStatusStats, setFileStatusStats] = useState<FileStats[]>(
    getStatusStats({ available: 0, sampling: 0, malwareScan: 0, received: 0 }),
  );
  useEffect(() => {
    const stats = getStatusStats(fileStatsData);
    setFileStatusStats(
      stats.map((stat, index) => {
        return {
          ...stat,
          percentage: Number(Object.values(percentageData)[index]),
        };
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileStatsData]);

  const getStatsData = (stat: FileStats) => {
    const percentage = stat.percentage || 0;
    let optionSelected = 'Last Month';
    switch (selectedOption) {
      case 1:
        break;
      default:
        optionSelected = `Last ${selectedOption} Months`;
        break;
    }
    return (
      <>
        <Flex alignItems='center'>
          <Text color={percentage > 0 ? '#29B769' : '#F66C86'} fontSize='md'>
            {percentage > 0 ? (
              <Icon as={AiOutlineArrowUp} sx={{ mb: -0.5 }} />
            ) : (
              <Icon as={AiOutlineArrowDown} sx={{ mb: -0.5 }} />
            )}{' '}
            {Math.abs(percentage)}%
          </Text>
          <Text fontSize='sm' ml={2} color='#98A6AD'>
            Since {optionSelected}
          </Text>
        </Flex>
      </>
    );
  };
  return (
    <Flex gap={3}>
      <Card mt={3} cardProps={{ w: '98%' }}>
        <Flex alignItems='center'>
          <Text fontSize='md' fontWeight='semibold' textTransform='uppercase'>
            FILE UPLOAD TREND
          </Text>
          <Flex ml='auto'>
            <Select
              options={SelectOptions}
              defaultValue={selectedOption}
              onChange={(value) =>
                setSelectedOption(parseInt(value.toString()))
              }
            />
          </Flex>
        </Flex>
        <ResponsiveContainer width={'100%'} height={230}>
          <BarChart
            margin={{ top: 25, right: 4, bottom: 0 }}
            width={500}
            height={400}
            data={chartData}
            style={{ position: 'relative', left: '-20px' }}
          >
            <Bar fill='#883B92' dataKey='Uploads' barSize={8} />
            <XAxis
              tickLine={false}
              dataKey={selectedOption === 1 ? 'day' : 'month'}
            />
            <YAxis allowDecimals={false} tickLine={false} />
            <ChartTooltip wrapperClassName='white-bg' cursor={false} />
          </BarChart>
        </ResponsiveContainer>
      </Card>
      <Flex
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '12px',
          width: '100%',
          marginTop: '12px',
        }}
      >
        {fileStatusStats.map((stat, index) => (
          <SummaryCard
            key={index}
            title={stat.title}
            details={stat.value}
            icon={<Icon as={stat.icon} color={stat.color} fontSize='2xl' />}
            iconsBackground={stat.background}
            footer={getStatsData(stat)}
          />
        ))}
      </Flex>
    </Flex>
  );
};
